export const INDICATOR_CODES_MAP = {
  1: '机柜断电',
  2: '点位偏移',
  3: '用户客诉',
};
export const INDICATOR_CUST_COMPLAINT_CODES_MAP = {
  1: '机柜断电',
  2: '点位偏移',
  31: '高风险客诉',
  321: '归还客诉-断电',
  322: '归还客诉-异物',
  33: '价格客诉',
  341: '用户差评-价格',
  342: '用户差评-外观',
  343: '用户差评-归还点不好找',
};
export const SERVICE_LEVEL_CODES_MAP = {
  1: '一钻',
  2: '二钻',
  3: '三钻',
  4: '四钻',
  5: '五钻',
};
export const SERVICE_LEVEL_NUMBER_CODES_MAP = {
  1: '1钻',
  2: '2钻',
  3: '3钻',
  4: '4钻',
  5: '5钻',
};
export const SERVICE_LEVEL_EXPLAIN_LIST = [
  {
    title: '服务等级：',
    value: '是从用户借还体验出发，通过对影响用户借还体验的核心因素的综合评定，衡量当前的服务质量。',
  },
  {
    title: '服务等级评定指标：',
    value: '断电率、用户综合客诉指数、偏移率，共3个指标。',
  },
  {
    title: '服务等级评定周期：',
    value: '月度评定，每个自然月评定一次，每月1日根据上月服务表现进行等级结果评定。',
  },
  {
    title: '服务等级评定标准：',
    value: '根据服务等级得分分别对应一钻至五钻服务等级。',
  },
];
export const INDICATOR_EXPLAIN_LIST = [
  {
    title: '机柜断电：',
    value: '即机柜断电24小时以上。',
  },
  {
    title: '点位偏移：',
    value: '即门店位置与门店机柜的位置距离超过100米。',
  },
  {
    title: '用户客诉：',
    value: '1、高风险客诉：即有用户通过政府平台发起订单消费投诉； \n2、价格客诉：即有用户对订单“计价规则有异议”而产生客诉；\n3、归还客诉：即有用户对订单“因机柜断电异物等异常导致充电宝已归还但无法结束订单”而产生的客诉；\n4、用户差评：即有用户对订单进行了“较差”“很糟”等不满意评价，包括但不限于“定价及价格”“机柜位置”“机柜外观”等因素。\n请联系您的业务经理进行处理。',
  },
];
